// extracted by mini-css-extract-plugin
export var alignCenter = "_av-d";
export var bannerShown = "_av-6";
export var buttonContent = "_av-0";
export var cardList = "_av-1";
export var centerContent = "_av-2";
export var chevron = "_av-3";
export var closePanelButton = "_av-k";
export var conversationContextContainer = "_av-l";
export var conversationDetailContainer = "_av-4";
export var detailWrapper = "_av-7";
export var dropdownButton = "_av-e";
export var dropdownTitle = "_av-9";
export var fullHeight = "_av-5";
export var hidden = "_av-a";
export var icon = "_av-b";
export var mergeSuggestionWrapper = "_av-m";
export var panel = "_av-i";
export var portalButtonsWrapper = "_av-c";
export var right = "_av-j";
export var tableSummaryContainer = "_av-8";
export var tableSummaryHeader = "_av-g";
export var threeDotsButton = "_av-f";
export var wide = "_av-h";